import axios from "axios";

export const API_ENDPOINT = process.env.VUE_APP_API_URL;

export const HTTP = axios.create({
  baseURL: `${API_ENDPOINT}`,
});
